export default "/fonts/vendor/@fontsource/space-mono/files/space-mono-vietnamese-700-normal.woff2?d4776fb499e0747dd2ba76d14748a708";